import { OktaAuthOptions } from '@okta/okta-auth-js'
import { getAppConfigSetting, REMOVE_WHITESPACE } from '../utils'

export const ROUTER_BASENAME = 'tradeprocessing'
export const LEGIT_SERVICE_CONFIG = {
  useSessionLogin: false,
  apiUrl: getAppConfigSetting('apiUrl'),
}

export const OKTA_DOMAIN = getAppConfigSetting('oktaUrl')
export const CLIENT_ID = getAppConfigSetting('clientId')

export const ISSUER = getAppConfigSetting('oktaIssuer')
export const HOST = window.location.href
export const REDIRECT_URI = `${window.location.origin}/${ROUTER_BASENAME}/`
export const LOGOUT_REDIRECT_URI = `${getAppConfigSetting('appsUrl')}/tradeprocessing`
export const SCOPES = 'openid profile email'

export const OKTA_CONFIG: OktaAuthOptions = {
  issuer: ISSUER,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scopes: SCOPES.split(REMOVE_WHITESPACE),
  pkce: true,
}

export const OKTA_WIDGET_CONFIG = {
  baseUrl: OKTA_DOMAIN,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  authParams: {
    issuer: ISSUER,
    pkce: true,
    scope: SCOPES.split(REMOVE_WHITESPACE),
  },
  features: {
    idpDiscovery: true,
  },
  idpDiscovery: {
    requestContext: getAppConfigSetting('oktaIdpDiscovery'),
  },
  logo: false,
  i18n: {
    en: {
      'primaryauth.title': 'Sign In',
      'primaryauth.username.placeholder': 'E-mail Address *',
      'primaryauth.password.placeholder': 'Password *',
      'error.username.required': 'Please enter an e-mail address',
      'error.password.required': 'Please use your Okta password',
      'oform.error.unexpected': 'Please use your e-mail address and Okta password',
      'primaryauth.submit': 'Sign In',
    },
  },
  colors: {
    brand: '#4079BC',
  },
}
